import { useEffect, useState } from 'react';

// HubSpot renders its launcher inside this fixed container in the parent document.
export const HUBSPOT_CONTAINER_SELECTOR = '#hubspot-messages-iframe-container, [id^="hubspot-messages-iframe"]';
// Below the assistant chat panel (1300) so an open chat covers the launcher; HubSpot's default is far
// higher and would otherwise sit on top of the chat.
export const HUBSPOT_LAUNCHER_Z_INDEX = '1250';

export function getHubspotContainer(): HTMLElement | null {
  return document.querySelector<HTMLElement>(HUBSPOT_CONTAINER_SELECTOR);
}

// Cap the launcher's z-index. Inline `important` beats HubSpot's own equal-specificity stylesheet
// rule (which loads later in the cascade); the caller re-asserts it since HubSpot rewrites the style.
export function pinHubspotLauncherZIndex(el: HTMLElement): void {
  if (el.style.zIndex === HUBSPOT_LAUNCHER_Z_INDEX) {
    return; // already pinned — don't retrigger the caller's observer
  }
  el.style.setProperty('z-index', HUBSPOT_LAUNCHER_Z_INDEX, 'important');
}

// Whether HubSpot's launcher is currently mounted, so the assistant button can sit beside it (and
// fall back to the corner when it isn't).
export function useHubspotLauncherPresent(): boolean {
  const [present, setPresent] = useState(() => Boolean(getHubspotContainer()));

  useEffect(() => {
    const check = () => setPresent(Boolean(getHubspotContainer()));
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return present;
}
